import {html} from 'lit-html';
import templateFilter from './template-filter';

const { __ } = wp.i18n;

const template = (data) => html`
<div class="project-offer-filter-wrapper" style="background-image: url('${data.props.filterBackgroundImageSrc}');">
	<div class="project-offer-filter-container content">
		<h2 class="project-offer-filter-title">${__('Search offers', 'real-estate-project')}</h2>
		<div class="project-offer-filters-container">
			${data.filters.map(filter => html`${templateFilter(data, filter)}`)}
		</div>
	</div>
</div>`;

export default template;